<template>
  <div ref="tabsContainer" class="tabs-container" :class="{ load: isLoading }">
    <ul class="nav-tabs" :class="classWrap">
      <li 
        v-for="tab in tabsArray" 
        :key="tab.id"
        v-show="tab.isShow"
        :class="[{ active: activeTab === tab.id}, classLi]"
        class="nav-pill"
        @click="activateTab(tab.id)">
          <span class="nav-tabs-link" :class="classLink">
            <p :class="classH5">{{ tab.name }}</p>
            <span v-if="tab.count && tab.count > 0" class="count" :class="classCount">{{ tab.count }}</span>
          </span>
      </li>
    </ul>
    <div v-if="!mobile" :style="indicatorStyle" class="indicator"></div>
  </div>
</template>

<script>
import { ref } from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from "swiper/modules";
import 'swiper/swiper-bundle.css';

export default {
  components: {
      Swiper,
      SwiperSlide,
  },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    classWrap: {
      type: String,
      default: ''
    },
    classLi: {
      type: String,
      default: ''
    },
    classLink: {
      type: String,
      default: ''
    },
    classH5: {
      type: String,
      default: ''
    },
    classCount: {
      type: String,
      default: ''
    },
    mobile: {
      type: Boolean,
      default: false
    },
    activeTab: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isLoading: true,
      tabsArray: this.tabs,
      indicatorStyle: {},
    };
  },
  setup() {
      const prev = ref(null);
      const next = ref(null);
      return {
          modules: [Navigation],
          prev,
          next,
      };
  },
  mounted() {
    this.$nextTick(() => {
      this.updateIndicatorPosition();
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    });
    setTimeout(() => {
      this.isLoading = false;
    }, 700);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    activateTab(id) {
      this.$emit('tab-changed', id);
      this.$nextTick(() => {
        this.updateIndicatorPosition();
      });
    },
    updateIndicatorPosition() {
      this.$nextTick(() => {
        const tabsContainer = this.$refs.tabsContainer;
        if (!tabsContainer) {
          console.warn('Tabs container not found');
          return;
        }

        const activeTab = tabsContainer.querySelector('li.active');
        const indicator = tabsContainer.querySelector('.indicator');
        
        if (activeTab && indicator) {
          const activeTabOffset = activeTab.offsetLeft;
          const activeTabWidth = activeTab.offsetWidth;
          
          this.indicatorStyle = {
            width: `${activeTabWidth}px`,
            transform: `translateX(${activeTabOffset}px)`,
            transition: 'transform 0.4s'
          };
        }
      });
    },
    handleResize() {
      // Optional: Update the indicator position based on resize
      this.updateIndicatorPosition();
    }
  },
  watch: {
    tabs() {
      this.tabsArray = this.tabs;
    }
  }
};
</script>
  
<style lang="scss">
  .tabs-container{
    position: relative;
    .indicator {
      position: absolute;
      bottom: 0;
      height: 100%;
      background: #354051;
      border-radius: 4px;
    }
    &.load{
      .indicator {
        background: transparent;
      }
      .nav-tabs .nav-pill.active .nav-tabs-link{
        background: #354051;
      }
    }
  }
  .nav-tabs{
    display: flex;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    border: none !important;
    .swiper-container{
      .tab-link{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        .tab-icon{
          display: flex;
          align-items: center;
        }
      }
    }
    .nav-pill{
        position: relative;
        border-radius: 5px;
        width: 100%;
        height: 40px;
        z-index: 2;
        .nav-tabs-link{
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 8px;
            font-family: "Roboto-Light", sans-serif;
            font-weight: 400;
            font-size: 16px;
            line-height: 1.5;
            text-transform: uppercase;
            background-color: transparent;
            color: #c0c3c9;
            border: none !important;
            transition: 0.4s;
            &:hover{
                color: #f6f6f6;
                background-color: transparent;
            }
        }
        @media only screen and (max-width: 1023px) {
          color: #f6f6f6;
        }
        &.active{
            .nav-tabs-link{
                color: #f6f6f6;
                font-family: "Roboto-Medium", sans-serif;
            }
        }
    }
}
</style>